var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.IsPurchase)?_c('PrintReportsSales',{attrs:{"dataProps":_vm.print}}):_c('PrintReportsPurchase',{attrs:{"dataProps":_vm.print}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }